import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {

  PackageList: any;
  SchoolList: any;
  BranchList: any;
  SubscriptionList: any;
  Submitted: boolean = false;  
  UserIDMsg:any;
  School:any;
  Country: any;
  State: any;
  City: any;
  CurrencyList:any;
  SelectedFileForUpload: any;
  Count:number=0;
  SchoolBrachResetList:any;
  PackagePriceList:any;
  constructor(private subcriptionService: SubscriptionService, private LookupService: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }
    BranchModel = {
      SubscriptionStatusID:0,
      City: '',
      CountryName:"",
      StateName:"",
      GroupName:"",     
      PackageID:0,
      PartnerID:0,
      
      BillingCycleID:0,
              BranchID: 0,
              SchoolID: 0,
              SubscriptionID: 0,
              BranchName: '',
              JosaBranchCode:'',
              BranchCode: '',
              RenewalDate: moment(new Date()).format('DD-MMM-YYYY') ,
              Phone: '',
             
              ContactNo: '',
              ContactPerson: '',
              IsActive: true,
              
              CityID: 0,
              StateID: 0,
              CountryID: 0,
              ZipCode: '',
              Address: '',              
              CurrencyID: 0,            
              POBox:'',
              Email:'',
              Fax:'',             
              StudentStrangth:150,
            
            
    };
    Clear() {
      this.PackagePriceList=null;
      this.BranchModel.GroupName = '';     
      this.BranchModel.StudentStrangth = 150;
      this.BranchModel.BillingCycleID = 0;
      this.BranchModel.PackageID = 0;
      this.BranchModel.BranchID = 0;
      this.BranchModel.BranchName = '';
      this.BranchModel.BranchCode = '';
      this.BranchModel.JosaBranchCode = '';
      this.BranchModel.POBox = '';
     
      this.BranchModel.Phone = '';
      
      this.BranchModel.ContactNo = '';
      this.BranchModel.ContactPerson = '';
      this.BranchModel.IsActive = false;
      
      this.BranchModel.CityID = 0;
      this.BranchModel.CountryID = 0;
      this.BranchModel.StateID = 0;
      this.BranchModel.ZipCode = '';
      this.BranchModel.Address = '';
      this.BranchModel.Email = '';
      this.BranchModel.Fax = '';
      this.BranchModel.PackageID = 0;
      this.BranchModel.PartnerID = 0;
      this.BranchModel.SubscriptionStatusID = 0;
      this.BranchModel.SubscriptionID = 0;
      this.BranchModel.City = "";
      this.Submitted = false;
     
      this.BranchModel.CurrencyID = 0;
    
     
    };
  validationDropDown() {
      return  this.BranchModel.CountryID == 0 ||this.BranchModel.StateID == 0
    }
    GetBindCountry() {
      this.LookupService.GetLookupsList('Country', '').subscribe((data: any) => {
        this.Country = data.LookupItems;
      });
    };
    PackageSaleList:any;
    GetPackageSale() {
      this.LookupService.GetLookupsList('PackageForSaleMap', '').subscribe((data: any) => {
        this.PackageSaleList = data.LookupItems;
      });
    };
    PartnerList:any;
    GetPartner() {
      this.LookupService.GetLookupsList('Partner', '').subscribe((data: any) => {
        this.PartnerList = data.LookupItems;
      });
    };
    SubscriptionStatusList:any;
    GetSubscriptionStatus() {
      this.LookupService.GetLookupsList('PackageSubscriptionStatus', '').subscribe((data: any) => {
        this.SubscriptionStatusList = data.LookupItems;
      });
    };
    BillingCycleList:any;
    GetBillingCycle() {
      this.LookupService.GetLookupsList('BillingCycle', '').subscribe((data: any) => {
        this.BillingCycleList = data.LookupItems;
      });
    };
    GetCurrency() {
      this.LookupService.GetLookupsList('Currency', '').subscribe((data: any) => {
        this.CurrencyList = data.LookupItems;
      });
    };
  
  
    GetBranchState() {
      var Itembo = {
        'ItemId': this.BranchModel.CountryID
      }
      this.LookupService.GetLookupsList('State', JSON.stringify(Itembo)).subscribe((data: any) => {
        this.State = data.LookupItems;
      });
    };
  
   
    GetBranchCity() {
      var Itembo = {
        'ItemId': this.BranchModel.StateID
      }
      this.LookupService.GetLookupsList('City', JSON.stringify(Itembo)).subscribe((data: any) => {
        this.City = data.LookupItems;
      });
    };
    UserList:any;
    IsExitsBranchCode=false;
    CheckBranchCodeExists() {
      this.IsExitsBranchCode=false;
      this.subcriptionService.CheckBranchCodeExists(this.BranchModel.BranchCode).subscribe((response: any) => {
        
        this.UserList = response.UserList;
     
        if(this.UserList!=null && this.UserList.length>0 ){
        this.IsExitsBranchCode=true;
       
        }
    
      });
    }
    IsExitsEmail=false;
    CheckUserExists() {
     this.IsExitsEmail=false;
      this.subcriptionService.CheckUserExists(this.BranchModel.Email).subscribe((response: any) => {
        this.UserList = response.UserList;
       
        if(this.UserList!=null && this.UserList.length>0 && this.BranchModel.SchoolID==0){
        this.IsExitsEmail=true;
        
        }
        
    
      });
    }

    josaBranchCode:any;
    RegisterSchool(valid) {
      
      this.Submitted = true;
      if (valid && !this.validationDropDown() && !this.IsExitsEmail && !this.IsExitsBranchCode) {
      this.spinnerService.show();
      this.subcriptionService.SuperAdminRegisterSchool(JSON.stringify(this.BranchModel),JSON.stringify(this.PackagePriceList)).subscribe((response: any) => {
      if(response.webResponse.Status){        
        this.josaBranchCode = response.josaBranchCode;
        this.globalHelper.CheckActionStatus(response);
        this.GetAllSubscription();
         this.Clear();
      }
       
       
        this.spinnerService.hide();
    
      });
    }
    };

    onSelectGroup(item){
      this.BranchModel.SchoolID=item.ItemId;
     }
     
     GetBranchSchool() {
       this.LookupService.GetLookupsList('School', '').subscribe((data: any) => {
         this.School = data.LookupItems;
         this.School.splice(0,1)
       });
     };

     Edit(obj) {
      
           
        this.BranchModel.City= obj.CityName,
        this.BranchModel.RenewalDate= obj.RenewalDate,
        this.BranchModel.CountryName=obj.CountryName, 
        this.BranchModel.CountryID=obj.CountryID,        
        this.BranchModel.GroupName=obj.DirectorName,       
        this.BranchModel.PackageID=obj.PackageID,
        this.BranchModel.PartnerID=obj.PartnerID,
        this.BranchModel.BillingCycleID=obj.BillingCycleID,
        this.BranchModel.BranchID= obj.BranchID,
        this.BranchModel.SchoolID= obj.SchoolID,
               
        this.BranchModel.BranchName= obj.BranchName,
        this.BranchModel.JosaBranchCode=obj.JosaBranchCode,
        this.BranchModel.BranchCode= obj.BranchCode,               
        this.BranchModel.Phone= obj.Phone,
        this.BranchModel.SubscriptionID= obj.SubscriptionID,
        this.BranchModel.ContactNo= obj.ContactNo,
        this.BranchModel.ContactPerson= obj.ContactPerson,
        this.BranchModel.IsActive= true,               
       
        this.BranchModel.CountryID= obj.CountryID,
        this.GetBranchState();
        this.BranchModel.CityID= obj.CityID,
        this.BranchModel.StateID= obj.StateID,
        this.BranchModel.ZipCode= obj.ZipCode,
        this.BranchModel. Address= obj.Address,                
        this.BranchModel. CurrencyID=obj.CurrencyID,
        this.BranchModel. POBox=obj.POBox,
        this.BranchModel.Email=obj.Email,
        this.BranchModel.SubscriptionStatusID=obj.SubscriptionStatusID,
        this.BranchModel. Fax=obj.Fax,
        this.BranchModel. StudentStrangth=obj.StudentStrangth
        this.BranchModel.RenewalDate= moment(obj.RenewalDate).format('DD-MMM-YYYY')!="01-Jan-0001"?moment(obj.RenewalDate).format('DD-MMM-YYYY'):'';
        
          
              
            
             
      
   }

  SearchModel = {
    SchoolID: 0,
    BranchID: 0,
    PackageID: 0,
    StartDate:'',
    EndDate:'',
    FromDate:'',
    ToDate:''
  }

  ClearSearch(){
    this.SearchModel.BranchID=0;
    this.SearchModel.SchoolID=0;
    this.SearchModel.PackageID=0;
    this.SearchModel.StartDate='';
    this.SearchModel.EndDate='';
    this.SearchModel.FromDate='';
    this.SearchModel.ToDate='';
  }

  GetAllSubscription() {
    this.SubscriptionList = [];
    this.spinnerService.show();
    this.SearchModel.FromDate =this.SearchModel.FromDate!=null && this.SearchModel.FromDate!=''?moment(this.SearchModel.FromDate).format('DD-MMM-YYYY'):'';
    this.SearchModel.ToDate =this.SearchModel.ToDate!=null && this.SearchModel.ToDate!=''?moment(this.SearchModel.ToDate).format('DD-MMM-YYYY'):'';
    this.SearchModel.StartDate =this.SearchModel.StartDate!=null && this.SearchModel.StartDate!=''?moment(this.SearchModel.StartDate).format('DD-MMM-YYYY'):'';
    this.SearchModel.EndDate =this.SearchModel.EndDate!=null && this.SearchModel.EndDate!=''?moment(this.SearchModel.EndDate).format('DD-MMM-YYYY'):'';
   
    this.subcriptionService.GetAllSubscription(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.SubscriptionList = data.SubscriptionList;
      this.spinnerService.hide();

    });
  };


  SubscriptionModel = {

    BranchID: 0,
    SchoolID: 0,
    PackageID: 0,
    SubscriptionID: 0,   

  }

  ClearSubscription() {
    this.Submitted = false;
    this.SubscriptionModel.SchoolID = 0;
    this.SubscriptionModel.BranchID = 0;
    this.SubscriptionModel.PackageID = 0;
  }


DisplayModel={
  DirectorName:'',
  JOSABranchCode:'',
  BranchName:'',
  BranchCode:'',
  Address:'',
  PackageName:'',
  PackageType:'',
  RegistrationDate:'',
  RenewalDate:'',
  BillingCycle:'',
}
  SubscriptionEdit(obj) {
     this.DisplayModel = obj;
  }

  
  // Validation() {
  //   return this.SubscriptionModel.PackageID == 0 || this.SubscriptionModel.SchoolID == 0 || this.SubscriptionModel.BranchID == 0;
  // }

  // SaveSubscription(valid) {
  //   this.Submitted = true;
  //   if (valid && !this.Validation()) {
  //     this.spinnerService.hide();
  //     this.subcriptionService.SaveSubscription(JSON.stringify(this.SubscriptionModel)).subscribe((data: any) => {

  //       if (data.webResponse.Status && this.SubscriptionModel.SubscriptionID == 0) {
  //         this.ClearSubscription();
  //       }

  //       if (data.webResponse.Status) {
  //         this.globalHelper.CheckActionStatus(data);
  //         this.GetAllSubscription();
  //       }

  //       this.Submitted = false;

  //     });
  //   }
  // };


  ngOnInit() {
    this.GetAllPackage();
    this.GetPartner();
    this.GetAccountSchool();
    this.GetBranch(0);
    this.GetAllSubscription();
    this.GetBillingCycle();
    this.GetPackageSale();
    this.GetBindCountry();    
    this.GetCurrency();
    this.GetBranchSchool();
    this.GetSubscriptionStatus();
  }


  GetAllPackage() {
    this.LookupService.GetLookupsList('PackageAll', '').subscribe((data: any) => {
      this.PackageList = data.LookupItems;
    });
  };

  GetAccountSchool() {
    this.LookupService.GetLookupsList('School', '').subscribe((data: any) => {
      this.SchoolList = data.LookupItems;
    });
  };

  GetBranch(SchoolID) {

    var Itembo = {
      'ItemId': SchoolID
    }
    this.LookupService.GetLookupsList('BranchBySchool', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.BranchList = data.LookupItems;
    });
  };

}
